module.exports = __webpack_public_path__ + "static/media/emma-frost-lose.58cb3fd4.png";